import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { AppService } from '../../../../app/app.service';
import { ComponentTypeVM } from '../../manage-components/manage-components.model';
import { SetupEquipmentService } from '../../setup-equipment/setup-equipment.service';
import { SelectionLists } from '../entities/global/model';
import { ComponentStatisticsVM, ForecastInspectionAverageVM, ForecastInspectionStatsResult, MachineForecastInspectionSeachResult, MachineForecastInspectionVM, MachineInspectionVM, ModelSelectionFilter, SerialNOSelectionFilter } from '../favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../favourite-dialog/favourite-dialog.service';
import { SafetyConfigService } from '../services/safety-config.service';
import { EquipmentSelectItem } from '../setup-equipment/setup-equipment.model';
import { GenericIdName } from '../setup-implement/setup-implement.model';

@Component({
  selector: 'app-forecast-inspection-statistics',
  templateUrl: './forecast-inspection-statistics.component.html',
  styleUrls: ['./forecast-inspection-statistics.component.scss']
})
export class ForecastInspectionStatisticsComponent implements OnInit {
  _dropDownLists: SelectionLists = new SelectionLists();
  constructor(
    private _safetyConfigService: SafetyConfigService,
    private _appService: AppService,
    private _equipmentService: SetupEquipmentService,
    private _favouriteDialogService:FavouriteDialogService,
  ) { }
  jobSiteName: string;
  modelName: string;
  selectedJobsite: number;
  selectedEquipment: number;
  equipmentList: EquipmentSelectItem[] = [];
  componentTypeList: GenericIdName[] = [];
  selectedModel: number;
  componenttypesList : ComponentTypeVM[];
  modelList: GenericIdName[] = [];
  selectedMakes: number[] = [];
  selectedFamily:number[]=[];
  selectedJobsiteArray: number[] = [];
  selectedModelArray: number[] = [];
  loading: boolean = false;
  startDate: Date;
  endDate: Date;
  MachineForecastInspectionResult: MachineForecastInspectionSeachResult;
  ComponentStatisticsResult: ForecastInspectionStatsResult[] = [];
  MachineInspectionResult:MachineInspectionVM[] = [];
  startSMU: number;
  endSMU: number;
  startCMU: number;
  endCMU: number;
  startDistance: number;
  endDistance: number;
  selectedMonth: number;
  selectedYear: number;
  selectedComponentType:number;
  selectedMake:number;
  selectedSide:number;
  inputValueScenario:string;
  ngOnInit() {
    debugger;
    const jobsites = this._appService.getJobSiteListForSelection(1, 10000);
    this._appService.setPageTitle('Advanced Undercarriage Forecasting');
    this.GetComponentTypesList();
    this.loadMakeList();
    this.loadModelList();
    this.GetSerialbyModelFamilyMake();
    Observable.forkJoin([jobsites]).subscribe(results => {
      this._dropDownLists.jobSiteList = results[0];
    });
  }

  scenarioinput = new FormControl("", [Validators.required]);
  getScenarioErrorMessage() {
    return this.scenarioinput.hasError("required") ? "You must select a value" : "";
  }

  jobsite = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.jobsite.hasError("required") ? "You must enter a value" : "";
  }

  modelid = new FormControl("", [Validators.required]);
  getModelErrorMessage() {
    return this.modelid.hasError("required") ? "You must enter a value" : "";
  }
  
  GetComponentTypesList(){
    this._equipmentService.GetComponentTypes().subscribe(res=>{
      console.log("component types", res)
      this.componenttypesList = res;
    })
  }

  loadModelList() {
    this.modelList = null
    var params: ModelSelectionFilter = {
      Families: [],
      Makes: this.selectedMakes
    }
    this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
      if (r) {
        this.modelList = r;
      }
    });
  }

  loadMakeList() {
      this._appService.getMakeListForSelection(1, 10000).subscribe(
        result => {
          this._dropDownLists.makeList = result;
        },
        error => {
          console.error(error);
        },
        () => {
          //this._loading--;
        }
      );
  }

  GetSerialbyModelFamilyMake() {
    this.equipmentList = null
    var params: SerialNOSelectionFilter = {
      Families: this.selectedFamily,
      Makes: this.selectedMakes,
      Models:this.selectedModelArray,
      Jobsites:this.selectedJobsiteArray
    }
    this._favouriteDialogService.GetSerialbyModelFamilyMake(params).subscribe(r => {
      if (r) {
        this.equipmentList = r;
      }
    });

  }

    jobsiteChanged(event:any) {
    
      let value = event.value;
      this.selectedJobsite = value.Id
  
    }
    submitSelection() {
      this.loading = true;
      var params: MachineForecastInspectionVM = {
        jobsite: this.selectedJobsite,
        equipment: this.selectedEquipment,
        models: this.selectedModel,
       
        startDate: this.startDate,
        endDate: this.endDate,
        startSMU:this.startSMU,
        endSMU:this.endSMU,
        startCMU:this.startCMU,
        endCMU:this.endCMU,
        startDistance:this.startDistance,
        endDistance:this.endDistance,
        selectedMonth:this.startCMU,
        selectedYear:this.selectedYear,
        selectedComponentType:this.selectedComponentType,
        selectedMake:this.selectedMake,
        selectedSide:this.selectedSide,
      }
  
      this._favouriteDialogService.GetMachineInspectionForecastSearchResult(params).subscribe(res => {
        console.log(res);
         this.MachineForecastInspectionResult = res;
         this.MachineInspectionResult = this.MachineForecastInspectionResult.MachineInspectionList;
         this.ComponentStatisticsResult = this.MachineForecastInspectionResult.ComponentStatisticsList;
         this.loading = false;
         this.jobSiteName = this.MachineInspectionResult[0].JobSiteName;
         this.modelName = this.MachineInspectionResult[0].ModelId;
         console.log(this.ComponentStatisticsResult);
        
      }); 
    }

    resetFields()
    {
    this.selectedMake = 0;
    this.selectedJobsite = 0;
    this.selectedEquipment = 0;
    this.selectedFamily = [];
    this.selectedModel = 0;
    this.startDate = null;
    this.endDate = null;
    }

    exportexcel(): void 
    {
       /* table id is passed over here */   
       let element = document.getElementById('export-data'); 
       const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

       /* generate workbook and add the worksheet */
       const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

       /* save to file */
       XLSX.writeFile(wb, "InspectionData.xlsx");
			
    }

    saveUpdateScenario() {
      debugger;
      this.loading = true;
      var params: ForecastInspectionAverageVM = {
        ComponentStatisticsAverageVM: this.MachineForecastInspectionResult.ComponentStatisticsList,
        modelid: this.selectedModel,
        jobsite: this.selectedJobsite,
        scenario: this.inputValueScenario,
        comments:null
      }
  
      this._favouriteDialogService.SaveUpdateScenario(params).subscribe(res => {
        console.log(res);
         //this.ComponentStatisticsResult = this.MachineForecastInspectionResult.ComponentStatisticsList;
         console.log(this.ComponentStatisticsResult);
        this.loading = false;
      }); 
			
    }

}
